import { mapReviewImagesError } from './mapReviewImagesError';

const PREFIX = 'admin.campaigns.submissions.bulkDisapprove.errors';

const KNOWN_BULK_DISAPPROVE_ERRORS = new Set([
  'reason_required',
  'reason_too_long',
  'too_many_submissions',
]);

type ErrorLike = {
  message?: unknown;
  graphQLErrors?: ReadonlyArray<{ message?: unknown }> | null;
};

/**
 * The i18n key for a failed bulk disapproval. Known backend codes get their
 * own message, image codes reuse the review-images copy, and anything else is
 * generic: raw backend text is never shown.
 */
export function mapBulkDisapproveError(err: ErrorLike | null | undefined): string {
  if (err == null) return `${PREFIX}.generic`;
  const candidates = [...(err.graphQLErrors ?? []).map((e) => e?.message), err.message];
  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const value = candidate.trim();
    if (KNOWN_BULK_DISAPPROVE_ERRORS.has(value)) return `${PREFIX}.${value}`;
  }
  return mapReviewImagesError(err) ?? `${PREFIX}.generic`;
}
